import { render, staticRenderFns } from "./SkillExerciseTask.vue?vue&type=template&id=c057da88&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./SkillExerciseTask.vue?vue&type=style&index=0&id=c057da88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057da88",
  null
  
)

export default component.exports